export const MEYA_INTEGRATION_ID = 'integration.orb'
export const MEYA_THREAD_ID = 'main'

export const ZD_FIELDS = {
  IID: 'zd_360015186739',
  USER_METADATA: 'zd_360015186759',
  LANGUAGE: 'zd_360015218700',
  PLATFORM: 'zd_21707382',
  GAME: 'zd_360015230900',
  SOC_ID: 'zd_360019940140',
  SIGNATURE: 'zd_360020117370',
  PORTAL_USER_ID: 'zd_360024578157'
}

export const UNIWEBVIEW_CLOSE_URL = 'uniwebview://event?playload=[SWVData]eyJtZXRob2QiOiJjbG9zZVZpZXciLCJhcmd1bWVudHMiOltdfQ=='
